// extracted by mini-css-extract-plugin
export default {"cell":"EnhancedTable_cell__L4VBl","print-only":"EnhancedTable_print-only__FR7GQ"};